import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetPositionWishesResponse extends BackendResponse {
  items: PositionWish[];
}

export const getPositionWishes =
  withNextApi<GetPositionWishesResponse>(
    "/cvp/CvpGetPositionWishesFromCandidate"
  );
  
  export interface PositionWish {
    item1: number;
    item2: number;
    item3: string;
  }
  